// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".element element--button element--button[data-v-5c6d662a]{border:2px solid #00d2e2;border-radius:50px}", ""]);
// Exports
module.exports = exports;
